
import ReactDOM from 'react-dom/client'
import React from 'react'
import './styles.css'
import * as THREE from 'three'
import { useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { OrbitControls, Center, Bounds, Line } from '@react-three/drei'
import allColors from './Colors'
import * as Tone from 'tone'
import anime from 'animejs/lib/anime.es.js';

const randI = (i) => Math.floor(i * fxrand())
const rand = (arr) => arr[randI(arr.length)]

Tone.Transport.bpm.value = 30
let ci = randI(allColors.length)

const colors = allColors[ci]
const bgColor = colors.shift()
const cols = colors
const accent = cols[0]

let dist = 0
let seqLength = 0
let dists = []
let scales = []
let getScale = () => {
  let x = rand([2, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 8, 8, 8, 8])
  return [
    x,
    rand([0.4, 0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 2, 3, 4, 5, 6]),
  ]
}
let rows = 1 + randI(12);
let columns = rand([16, 32, 48]);
new Array(rows).fill().forEach((_, i) => {
  dists[i] = dist
  scales[i] = getScale()
  dist = dist + scales[i][1]
  seqLength += columns / scales[i][0]
})

const feats = window.$fxhashFeatures = {
  mainUnit: rand(['2m']),
  seq: 2,
  bg: bgColor,
  accent: cols[0],
}
let anim = {
  dist: 1,
}

let filters = []
let pans = []
const instNotes = ['G2', 'A2', 'C3', 'D3', 'E3', 'A3', 'G3', 'C4', 'D4', 'E4']
let pansAmt = instNotes.length
let spread = 1.5
new Array(pansAmt).fill().map((_, i) => {
  pans[i] = new Tone.Panner((((spread / pansAmt) * i) - (spread * 0.5)) + (spread / (pansAmt * 2))).toDestination()
  filters[i] = new Tone.Filter(3000 + (10 * randI(10)), "bandpass", -12).connect(pans[i])
})

const insts = {};
const reversed = {};

instNotes.forEach((n, i) => {
  insts[n] = new Tone.Sampler({ urls: { C3: "./teropa/scale-" + n + ".mp3" } })
  reversed[n] = new Tone.Sampler({ urls: { C3: "./teropa/scale-" + n + ".mp3" } })
  insts[n].connect(filters[i])
  insts[n].attack = 0.1
  insts[n].release = 0.4
  reversed[n].release = 0.4
  reversed[n].volume.value = -2

  reversed[n].connect(filters[i])
})
const mods = [1, 1, 4, 8, 15]
const loopMods = []
const progress = {}

const r = []
new Array(feats.seq * 2).fill().map((_, i) => {
  r.push(Tone.Time(feats.mainUnit).toSeconds() * i)
})
const loopTime = Tone.Time(feats.mainUnit).toSeconds() * 2
const getVel = () => (6.8 + (randI(10) * 0.01))
let rots = [0.1]
const seqs = [
  r.map((time, i) => ({
    time,
    velocity: getVel() * 0.3,
    i,
    seq: 0,
    oct: rand([2, 2, 2, 2, 2]),
    rotX: rand(rots) * Math.PI,
    rotY: rand(rots) * Math.PI
  })),
]
let notes = []
let genNotes = () => {
  notes[0] = seqs.map((s, i) => r.map(() => rand(instNotes)))
  notes[1] = seqs.map((s, i) => r.map(() => rand(instNotes)))
  notes[2] = seqs.map((s, i) => r.map(() => rand(instNotes)))
  notes[3] = seqs.map((s, i) => r.map(() => rand(instNotes)))
}
genNotes()

seqs.forEach((v, i) => {
  progress['p' + i] = 0
  loopMods[i] = mods[i]
})

let modCount = 0;
let currRot = [0, 0];
let dir = false;
let part = new Tone.Part(((time, { velocity, i, seq, oct, rotX, rotY }) => {
  let n = notes[i % notes.length]
  if (!i && seq === 0) {
    modCount++;
  }
  if (!velocity) {
    return
  }
  currRot = [currRot[0] + rotX, currRot[1] - rotY]
  if ((modCount % loopMods[seq] === 0)) {
    let n1 = n[seq][i]
    let n2 = n[seq][(i + 1) % n[seq].length]
    let n3 = n[seq][(i + 3) % n[seq].length]
    let n4 = n[seq][(i + 4) % n[seq].length]
    let n5 = n[seq][(i + 5) % n[seq].length]
    let n6 = n[seq][(i + 6) % n[seq].length]
    let v = velocity * 1
    insts[n1].triggerAttackRelease(('C' + oct), loopTime, time, v);
    insts[n2].triggerAttackRelease(('C' + oct), loopTime, time, v);
    insts[n3].triggerAttackRelease(('C' + oct), loopTime, time, v);
    insts[n4].triggerAttackRelease(('C' + oct), loopTime, time, v);
    insts[n5].triggerAttackRelease(('C' + oct), loopTime, time+(loopTime*0.5), v);
    insts[n6].triggerAttackRelease(('C' + oct), loopTime, time+(loopTime*0.5), v);
    reversed[n1].triggerAttackRelease(('C' + oct), loopTime, time, v);
    reversed[n2].triggerAttackRelease(('C' + oct), loopTime, time, v);
    reversed[n3].triggerAttackRelease(('C' + oct), loopTime, time, v);
    reversed[n4].triggerAttackRelease(('C' + oct), loopTime, time, v);
    anim.dist = dir ? -1 : 1
    anime({
      targets: anim,
      dist: Math.abs(anim.dist) < 0.1 ? (dir ? -1 : 1) : (dir ? -0.0005 : -0.0005),
      easing: 'easeInQuart',
      duration: loopTime * 495
    })
  }
  dir = !dir
}), seqs.flat())
currRot = [seqs[0][0].rotX, seqs[0][0].rotY]
part.loop = true
part.loopEnd = loopTime

let s = 0.2
let z = s / 5
let z2 = s / 20

function Shapes() {
  let yPush = rand([0,0,0,(randI(5) * rand([1, -1]) * 0.1)])
  let shapes = [
    new THREE.Shape()
      .arc(s, s, s, Math.PI * 0.2, Math.PI * 1.8)
      .lineTo(s * 0.5, (s * 0.8) + yPush)
      .lineTo(s * 1.5, (s * 1.2) + yPush)
      .lineTo(s * 0.5, (s * 1.5) + yPush),
    new THREE.Shape()
      .arc(s, s, s, Math.PI * 0.2, Math.PI * 1.8)
      .lineTo(s * 0.5, (s * 1.1) + yPush),
    new THREE.Shape()
      .arc(s, s, s, Math.PI * 1, Math.PI * 0.5, true)
      .lineTo(s, (s)+ yPush)
      .arc(s, 0, s, Math.PI * 1, Math.PI * 0.5, true)
      .lineTo(s * 2, (s)+ yPush)
      .arc(0, 0, s, Math.PI * 1.5, Math.PI * 1, true).arc(0, 0, s, Math.PI * 1.5, Math.PI * 1, true)
    ,
    new THREE.Shape().arc(s, s, s, 0, Math.PI * 2)
  ]
  let hole = new THREE.Path([
    new THREE.Vector2(s + z2, s + z),
    new THREE.Vector2(s - z2, s + z),
    new THREE.Vector2(s - z2, s - z),
    new THREE.Vector2(s + z2, s - z),
  ])
  hole.closePath()
  shapes[shapes.length - 1].holes.push(hole)
  let geos = []
  let points = []
  let holePoints = []
  hole.getPoints(4).forEach((v, i) => {
    holePoints.push([v.x, v.y, 0])
  })
  shapes.forEach((s, i) => {
    let geo = new THREE.ShapeGeometry(shapes[i], 32)
    geos.push(geo)
    points[i] = []
    shapes[i].closePath()
    shapes[i].getPoints(192).forEach((v, j) => {
      points[i].push([v.x, v.y, 0])
    })
  })
  let fillCol = rand([-1,-1,-1,randI(columns)])
  return (
    <group rotation={[0, 0, rand([0,0,0,1,2,2,2,2,3]) * Math.PI * 0.5]}>
      {new Array(rows).fill().map((_, y) => {
        let thick = randI(10) * 0.015  
        let fill = randI(100)>90
        let dir = rand([true, false])
        return <group key={y}>
          {(new Array(columns).fill().map((_, x) =>
            (x < (columns / scales[y][0])) &&
            <Shape
              geo={geos[(x) % geos.length]}
              shapes={shapes}
              points={points[x % geos.length]}
              x={x}
              y={y}
              scales={scales}
              dists={dists}
              hole={holePoints}
              thick={thick}
              fill={fill || (fillCol === x)}
              dir={dir}
              key={x}
            />
          ))}
        </group>
      }
      )}
    </group>
  )
}
function Shape({ geo, shapes, points, x, y, scales, dists, hole, thick, fill, dir }) {
  const all = useRef()
  const l1 = useRef()
  const l2 = useRef()
  const mat = useRef()
  const outer = useRef()
  let size = 0.2
  let getV = (t, x, y, o) => (Math.floor(modes[(mode + o) % modes.length](t, x, y))) < 0 ? 0 : 1
  let getPos = () => [
    (x * 0.065 + ((x + 1) % 4 === 0 ? 0.015 : 0) + (0.01 * Math.floor((x / shapes.length)))) * scales[y][0],
    0.08 * dists[y],
    0
  ]
  useFrame((state) => {
    let tm = 0.1
    let v = getV(state.clock.getElapsedTime() * tm, x, y, 0)
    let v1 = getV(state.clock.getElapsedTime() * tm, x, y, 1)
    let v2 = getV(state.clock.getElapsedTime() * tm, x, y, 2)
    all.current.position.set(
      ...getPos()
    )
    let vr = (v || v1 || v2) 
    if(fill){
      mat.current.visible = vr
    }else {
        l1.current.visible = vr
        l2.current && (l2.current.visible = vr)
    }
  })
  let lw = Math.min(6,Math.max(0.5 + (Math.floor(x / (4)) * thick * scales[y][1]),1))
  return (
    <group scale={[0.35, 1, 1]}>
      <group ref={all} scale={[size * scales[y][0] * ((x % 4) > 2 ? 0.75 : 1), size * scales[y][1], size]} position={[...getPos()]} >
        <mesh geometry={geo} >
          <meshBasicMaterial ref={mat} color={accent} transparent opacity={fill ? 1 : 0} side={THREE.DoubleSide} />
        </mesh>
        <group ref={outer} position={[-0.0014 / size, 0, 0.0005 / size]}>

          {!fill && <Line
            lineWidth={lw}
            color={accent}
            points={points}
            ref={l1}
          />}
          {((x + 1) % 4 === 0) && !fill &&
            <Line
              lineWidth={Math.max(1, lw * 0.5)}
              color={accent}
              points={hole}
              ref={l2}
            />}
        </group>
      </group>
    </group>
  )
}
function Rig() {
  const startZ = useRef()
  const frame = useRef(0)

  return useFrame((state) => {
    if (typeof startZ.current === 'undefined' && frame.current > 10) {
      startZ.current = state.camera.position.z
    }
    frame.current += 1
    if (startZ.current) {
      state.camera.position.set(
        0, 0, anim.dist * startZ.current
      )
    }
  })
}

export default function App() {
  const start = () => {
    if (Tone.Transport.state !== 'started') {
      Object.keys(reversed).forEach((k, i) => {
        reversed[k]._buffers._buffers.get('48')._reverse()
      })
      Tone.start();
      Tone.Transport.start();
      part.start();
    }
  }
  return (
    <div id="main" onClick={() => start()}>
      <Canvas dpr={[1, 2]} camera={{ near: 0.000000000000001, fov: 150 }}>
        <Bounds damping={0} fit margin={0.3}>
          <Center>
            <Shapes />
          </Center>
        </Bounds>
        <OrbitControls autoRotate autoRotateSpeed={0} rotateSpeed={1.5} dampingFactor={0.005} />
        <Rig />
      </Canvas>
    </div>
  )
}

let modes = [
  (t, c, r) => Math.cos(c / 3 + Math.cos(r / 5 + t * 0.1) * 4) * 2,
  (t, c, r) => Math.cos(2 * r / c ^ 2 + t),
  (t, c, r) => Math.sin(0.5 * Math.atan2(r - 3, c) + t),
  (t, c, r) => Math.sin(t * r * c / ((r * columns) + c) * 4),
  (t, c, r) => (((-t * 0.2) * 9 + c - r * Math.tan(4) ^ c * Math.tan(4) + r) & 8) - 1,
  (t, c, r) => Math.cos(t * 1 + Math.sqrt(c * r * 0.05)) + .5,
  (t, c, r) => Math.min(0, c / r * (Math.hypot(c + Math.cos(t) - (columns * 0.5), r - (rows * 0.5)) - 5)),
  (t, c, r) => [7, 5, 3, 1].reduce((a, b) => r > a + a / 2 * Math.cos(c / a + (t * 2) * a) ? -a / 3 : b),
  (t, c, r) => (c + r < Math.max(rows, columns)) * ((c + r) < Math.ceil(Math.max(rows, columns) * 0.5) ? 1 : -1) || (c - r < 1),
  (t, c, r) => [8, 5, 3, 1].reduce((a, b) => r > a + a / 2 * Math.cos(c / a + t * a) ? -a / 5 : b),
  (t, c, r) => c < 13 ? ((Date.now() + '')[c] - 5) / 5 : 0,
  (t, c, r) => Math.sin(c / 8 + t) % Math.sin(r + t),
  (t, c, r) => ((c + (r + t * 9) ^ c - (r + t * 9)) % 13 & 1) - .15,
  (t, c, r) => .01 / Math.sin(3 ** ++c - Math.atan2(c, c * r) * 3 - t),
  (t, c, r) => Math.tan(Math.sin(r / 3 - t * 2) + Math.cos(c / 2 - t * 3)),
]
let mode = randI(modes.length)

const root = document.getElementById('root');
root.style.background = bgColor
ReactDOM.createRoot(root).render(
  <>
    <App />
  </>
)
console.log('🗣️🗣️ @ramioso 2022-04-17 🗣️🗣️')